import React, { useMemo } from "react";
import "./HowMarketingWorks.css";

function HowMarketingWorks() {
  const steps = useMemo(
    () => [
      {
        number: "01",
        title: "Choose a Marketing Tool",
        description:
          "Select SEO, email campaigns, brand promotion, social media, or lead generation services.",
      },
      {
        number: "02",
        title: "Submit Secure Details",
        description:
          "Fill out your requirement form. Your lead data stays clean, token-ready, and user-specific.",
      },
      {
        number: "03",
        title: "Track and Start Growing",
        description:
          "Your request is synced with the backend so the team can process it without data mismatch.",
      },
    ],
    []
  );

  return (
    <section className="marketing-section hmw-section" id="marketing-how-it-works">
      <div className="marketing-container hmw-container">
        <div className="marketing-section-heading hmw-heading">
          <span className="marketing-section-badge hmw-badge">How It Works</span>

          <h2 className="marketing-section-title hmw-title">
            Simple Steps to Start Marketing Online
          </h2>

          <p className="marketing-section-text hmw-text">
            A secure, clean, and production-ready workflow for managing marketing
            leads and growth requests.
          </p>
        </div>

        <div className="marketing-steps-grid hmw-grid">
          {steps.map((step, index) => (
            <article className="marketing-step-card hmw-card" key={step.number}>
              <div className="hmw-top-row">
                <div className="marketing-step-number hmw-number">
                  {step.number}
                </div>

                {index !== steps.length - 1 && (
                  <span className="hmw-arrow">→</span>
                )}
              </div>

              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowMarketingWorks;